<template>
  <div>
    <base-dialog :show="!!error" title="An error occurred" @close="handleError">
      <p>{{ error }}</p>
    </base-dialog>
    <base-dialog :show="isLoading" title="Authenticating..." fixed>
      <base-spinner></base-spinner>
    </base-dialog>
    <base-card :class="{isMobile:isMobile}">

      <div class="logo-field">
        <router-link :to="homeurl()"><main-logo /></router-link>
      </div>
      <div class="register-title">{{ siteName }} 회원가입</div>
      <form @submit.prevent="submitForm2">
        <fieldset>
          <legend>회원가입</legend>
          <div class="register_set">

            <dl id="register-field" class="input_list">

              <dt class="display_none" >
                <label for="mb_id">이메일 입력</label>
              </dt>
              <dd class="dd_mb_id" :class="{invalid: !email.isValid}">
                <input type="email" name="email"
                v-model.trim="email.val"
                placeholder="이메일"
                autocomplete="off"
                @blur="clearValidity('email')">
              </dd>

              <dt class="display_none" >
                <label for="mb_password">비밀번호 입력</label>
              </dt>
              <dd class="dd_mb_pw" :class="{invalid: !password.isValid}">
                <input type="password"  name="password"
                v-model.trim="password.val"
                placeholder="비밀번호(6자리 이상)"
                autocomplete="off"
                @blur="clearValidity('password')">
              </dd>

              <dt class="display_none" >
                <label for="mb_password">비밀번호 확인</label>
              </dt>
              <dd class="dd_mb_pw" :class="{invalid: !passwordConfirm.isValid}">
                <input type="password"  name="passwordConfirm"
                v-model.trim="passwordConfirm.val"
                placeholder="비밀번호 확인"
                autocomplete="off"
                @blur="clearValidity('passwordConfirm')">
              </dd>

              <dt class="display_none" >
                <label for="mb_nic">닉네임 입력</label>
              </dt>
              <dd class="dd_mb_pw" :class="{invalid: !nic.isValid}">
                <input type="text"  name="nic"
                v-model.trim="nic.val"
                placeholder="사용할 닉네임"
                autocomplete="off"
                @blur="clearValidity('nic'),ckNic($event)">
              </dd>

              <dt class="display_none" >
                <label for="mb_recommender">추천인 입력</label>
              </dt>
              <dd class="dd_mb_pw" >
                <input type="text"  name="recommender"
                v-model.trim="recommender.val"
                placeholder="추천인"
                autocomplete="off"
                >
              </dd>

            </dl>

            <div class="acc">
              <div class="register_state">
                <label id="privacy_label" for="privacy_chk" class="privacy_label" @click="agree($event)">
                  <span id="icheck" class="icheck">
                    <input id="privacy_chk" type="checkbox" class="privacy_chk" name="privacy_chk" value="agree"
                    v-model="agreepolicy.val"
                    @blur="clearValidity('agreepolicy')">
                  </span>
                  <a href="javascript:void(0)" class="policy" @click="policy_view('service')">이용약관</a> 및
                  <a href="javascript:void(0)"  class="policy" @click="policy_view('privacy')">개인정보 수집 및 이용안내</a>에 동의 합니다.
                </label>
              </div>
            </div>
            <!-- 약관 -->
            <div class="policy-area" v-if="policyView">
              <dl>
                <dt>
                  <span> {{switchPolicytitle}}</span>
                  <span class="btn_close" @click="close_policyView">
                    <img src="@/assets/imgs/btn_close.png">
                  </span>
                </dt>
                <dd>
                  <policy-service :quicklink="false" v-if="ispolicyservice"/>
                  <policy-privacy :quicklink="false" v-if="ispolicyprivacy"/>
                </dd>
              </dl>
            </div>

            <div v-if="!formIsValid" class="alert-valid">
              <div><span class="ic_alert"></span></div>
              <div class="text">입력 사항을 다시 확인 해 주세요!!!</div>
            </div>
            <div v-if="!agreepolicy.isValid" class="alert-valid">
              <div><span class="ic_alert"></span></div>
              <div class="text">이용약관 및 개인정보 수집 및 이용안내에 동의 해 주세요</div>
            </div>

            <div style="text-align:center;display:none">
              가입후 이메일 인증이 필요합니다.(이메일을 확인해 주세요)
            </div>

            <base-button mode="red">{{ submitButtonCaption }}</base-button>
          </div>
        </fieldset>
        </form>
        <div class="login-tip">         
            이미 {{ siteName }} 회원이시면 <router-link :to="goLogin()">로그인</router-link> 해주세요.
        </div>
        <div class="reg_ft">
           <template v-if="isMobile">
              <div class="policylink">
                <span @click="popupPolicy('service')">이용약관</span>
                <span @click="popupPolicy('privacy')">개인정보취급방침</span>
                <span @click="popupPolicy('youth')">청소년보호정책</span>
              </div>    
            </template>
            <template v-else >
              <ul>
                  <li><router-link to="/main/policy/service" target="_blank">이용약관</router-link><span class="bar"></span></li>
                  <li><router-link to="/main/policy/privacy" target="_blank"><strong>개인정보취급방침</strong></router-link><span class="bar"></span></li>
                  <li><router-link to="/main/policy/youth" target="_blank">청소년보호정책</router-link><span class="bar"></span></li>
                  <!-- <li><router-link to="/main/policy/service" target="_blank">{{ siteName }}도움말</router-link></li> -->
              </ul>
            </template>
           
        </div>
        <div class="footer">Copyright (c){{ siteName }}. All Rights Reserved.</div>
         <base-dialog :show="chosepolicy !== null" @close="popupClose" :isMobile="true" >
            <div class="policywrap">
              <policy-service v-if="chosepolicy ==='service'" :isMobile="true"/>
              <policy-privacy v-if="chosepolicy ==='privacy'" :isMobile="true"/>
              <policy-youth v-if="chosepolicy ==='youth'" :isMobile="true"/>
            </div>
        </base-dialog>
    </base-card>
  </div>
</template>

<script>
//import * as auth from '@/services/auth_service';
import PolicyService from '@/components/policy/Service'
import PolicyPrivacy from '@/components/policy/Privacy'
import { ckregister } from '@/components/mixins/ckRegisterUser'
import PolicyYouth from '@/components/policy/Youthpolicy'
export default {
  data() {
    return {
      email: {
        val:'',
        isValid:true,
      },
      password: {
        val:'',
        isValid:true,
      },
      passwordConfirm:{
        val:'',
        isValid:true,
      },
      nic:{
        val:'',
        isValid:true
      },
      recommender:{
        val:''
      },
      agreepolicy:{
        val:[],
        isValid:true
      },
      formIsValid: true,
      mode: "register",
      isLoading: false,
      error: null,
      ispolicyservice:false,
      ispolicyprivacy:false,      
      chosepolicy:null
    };
  },
  props:{
    isMobile:{default:false}
  },
  mixins: [
    ckregister
  ],
  components:{
    PolicyService,
    PolicyPrivacy,  
    PolicyYouth 
  },
  computed: {
    siteName(){
      return this.$store.state.siteName;
    },
    submitButtonCaption() {
      if (this.mode === "register") {
        return "가입하기";
      } else {
        return "Signup";
      }
    },
    switchPolicytitle(){
      if(this.ispolicyservice)
      {
        return '이용약관';
      }else{
        return '개인정보 수집 및 이용 안내';
      }
    },
    switchModeButtonCaption() {
      if (this.mode === "register") {
        return "가입하기";
      } else {
        return "register instead";
      }
    },
    policyView(){
      if(this.ispolicyservice===true || this.ispolicyprivacy===true){
        return true;
      }else{
        return false;
      }
    },
    getchosepolicy(){
      return this.chosepolicy;
    }

  },
  methods: {
    popupPolicy(policy){
      this.chosepolicy = policy;      
    },
    popupClose(){     
      
      this.chosepolicy = null; 
    },
    goLogin(){
      if(this.isMobile)
      {
        return '/m/login'
      }else{
        return '/auth/login';
      }
    },
    clearValidity(input) {
      if(this[input].val !=='')
      {
        this[input].isValid = true;
      }
    },
    validateForm() {
      this.formIsValid = true;
      //이메일 체크
      if (this.email.val === '' ||  !this.email.val.includes("@"))
      {
        this.email.isValid = false;
        this.formIsValid = false;
      }

      //비밀번호 체크
      if (this.password.val === '' || this.password.val.length < 6)
      {
        this.password.isValid = false;
        this.formIsValid = false;
      }

      //비밀번호 확인 체크
      if (this.passwordConfirm.val === '' || this.password.val != this.passwordConfirm.val)
      {
        this.passwordConfirm.isValid = false;
        this.formIsValid = false;
      }

      if (this.nic.val === '')
      {
        this.nic.isValid = false;
        this.formIsValid = false;
      }
      if (this.agreepolicy.val.length === 0)
      {
        this.agreepolicy.isValid = false;
      }
    },
    async submitForm() {
      this.formIsValid = true;
      if (
        this.email === "" ||
        !this.email.includes("@") ||
        this.password.length < 6
      ) {
        this.formIsValid = false;
        return;
      }

      this.isLoading = true;

      const actionPayload = {
        email: this.email,
        password: this.password,
      };

      try {
        if (this.mode === "register") {
          await this.$store.dispatch("register", actionPayload);
        } else {
          await this.$store.dispatch("signup", actionPayload);
        }
        const redirectUrl = "/" + (this.$route.query.redirect || "coaches");
        this.$router.replace(redirectUrl);
      } catch (err) {
        this.error = err.message || "Failed to authenticate, try later.";
      }

      this.isLoading = false;
    },
    async submitForm2() {
      this.validateForm();
      if (!this.formIsValid) {
        return;
      }
      if(!this.agreepolicy.isValid)
      {
        return;
      }
      this.isLoading = true;
      const actionPayload = {
        email: this.email.val,
        password: this.password.val,
        password_confirmation: this.passwordConfirm.val,
        nic : this.nic.val,
        recommender : this.recommender.val
      };

      try {
        //const response = await auth.register(actionPayload);
        const response = await this.$store.dispatch("signup", actionPayload);
        console.log(response);
        //회원가입후 로그인 시킴
        this.$store.dispatch("login", actionPayload);
        if(this.isMobile)
        {
           this.$router.replace("/m");
        }else{
           this.$router.replace("/");
        }
       
        
        this.$flashMessage.show({
          type: "info",
          title: response.message,
          message: response.message,
        });
      } catch (error) {
        console.log(error.response);
        switch (error.response.status) {
          case 422:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          case 401:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          case 500:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          default:
            this.$flashMessage.show({
              type: "error",
              title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
              message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
            });
            break;
        }
      }
      this.isLoading = false;
    },
    switchAuthMode() {
      if (this.mode === "register") {
        this.mode = "signup";
      } else {
        this.mode = "register";
      }
    },
    handleError() {
      this.error = null;
    },
    agree($event){
      if($event.target.id === 'privacy_label' || $event.target.id === "icheck")
      {
        document.querySelector('#privacy_label').classList.toggle('agree');
      }
    },
    policy_view(policy){
      if(policy === "service")
      {
        if(this.ispolicyservice===true)
        {
          this.ispolicyservice=false;
        }else{
          this.ispolicyservice=true;
        }
        this.ispolicyprivacy=false;
      }else{
        if(this.ispolicyprivacy===true)
        {
          this.ispolicyprivacy=false;
        }else{
          this.ispolicyprivacy=true;
        }
        this.ispolicyservice=false;
      }
    },
    close_policyView(){
      this.ispolicyservice=false;
      this.ispolicyprivacy=false;
    },
    homeurl(){
      if(this.isMobile)
      {
        return '/m';
      }else{
        return '/';
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.isMobile{
  padding:10px 10px 50px 10px  !important;
  form{
    padding: 0 !important;
  }
  
  
}
form {
  margin: 1rem;
  padding: 0 1rem 0 1rem;
  margin-bottom:0;
  font-family:굴림,gulim;
}
.logo-field{
    text-align:center;
    padding:20px 0;
}
.register-title{
    font-weight:bold;
    padding-left:2rem;
    font-size:16px;
    font-family:malgungothic
}
fieldset{
  border: 0;
  legend{display:none;}
  .register_set{
    .input_list{
        input{
            padding:0 20px;
            border: 1px solid #dadada;
            font-size: 12px;
            width:100%;
            line-height:50px;
        }
        dd{
            margin-bottom:10px;
        }
    }
    .invalid{
      input{
        border: 1px solid #c30;
      }
    }
  }
  .acc{
      margin:20px 0;
      display:flex;
      justify-content: space-between;
      font-size:12px;
      color: #999;
      .privacy_label{
        cursor:pointer;
        a{
          text-decoration:underline;
          color: #999;
        }
        .icheck{
          margin-right: 7px;
          width: 19px;
          height: 19px;
          background: url(../../assets/imgs/sp_account.png) no-repeat;
          display:inline-block;
          text-indent: -9999px;
          cursor:pointer;
        }
      }
      .agree{
          color:#c30;
          .icheck
          {
            background: url(../../assets/imgs/sp_account.png) no-repeat -30px 0;
          }
          a{color:#c30;}
        }

  }
  .alert-valid{
      font-size:12px;
      color:#b72e00;
      display:flex;
      .ic_alert{
        display:inline-block;
        width:15px;
        height:15px;
        background: url(../../assets/imgs/sp_account.png) no-repeat -60px 0;
      }
      .text{padding-left:10px;}
  }
  .policy-area{
    margin-bottom:20px;
    border:1px solid #dcdddd;
    dt{
      line-height: 51px;
      border-bottom: 1px solid #d6d6d6;
      background-color: #fbfbfc;
      display:flex;
      justify-content: space-between;
      span{
        padding:0 20px;
      }
    }
    dd{ height:100px; overflow-y:auto;}
  }
}
.login-tip{
    margin: 5px 0 28px 0;
    line-height: 15px;
    text-align: center;
    color: #4c4c4c;
    font-size:12px;
    a{
        text-decoration:underline;
        font-weight:bold;
    }
}
.bar{
    margin: 4px 10px 0;
    width: 1px;
    height: 11px;
    background-color: #e5e5e5;
    display: inline-block;
}
.reg_ft{
    border-top:1px solid #ededed;
    padding:20px 0 10px 0;
    margin: 0 40px;
    font-size:12px;
    ul{
      display:flex;
      justify-content: center;
    }
    .policylink{
      display: flex;
      justify-content: space-between;
    }
}
.footer{
    font-size: 10px;
    font-family: Arial,Helvetica,sans-serif;
    text-align: center;
    color: #999;
}
.btn_close{
  cursor:pointer;
  /*
  display:inline-block;
  text-indent:-9999px;
  overflow:hidden;
  width: 11px;
  height: 11px;
  background: url(../../assets/imgs/btn_close.png);
  */
}
.policywrap{
  height:calc( 100vh - 300px);
  overflow-y: scroll;
}
</style>
